import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateAccommodationRoomType($companyId: ID!, $id: ID!, $attributes: AccommodationRoomTypeAttributes!) {
    updateAccommodationRoomType(companyId: $companyId, id: $id, attributes: $attributes) {
      accommodationRoomType {
        id
        ...UpdatedAccommodationRoomType
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedAccommodationRoomType on AccommodationRoomType {
    id
    capacity
    layout
    name
    notes
  }
`
